import { EventType } from './event-type.interface';

export const LIGHT: EventType = {
  name: 'Light',
  description: 'When a Light is turned on or off',
  route: 'light',
  category: 'Lights',
  icon: 'lightbulb',
  order: 3,
  whitelist: [
    {
      proxy: 'light_v2',
      events: [5100, 5101]
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/light.type.ts